import React from 'react';
import T from 'prop-types';

import MediaObject from '../../../../components/MediaObject';
import Chart from './Chart';

const Slide = ({ data, isActive }) => (
  <div className="models-slide-content">
    <div className="models-slide-content-header">
      <MediaObject
        icon_url={data.app_icon_url}
        name={data.app_name}
        publisher_name={data.publisher_name}
        publisher_id="stub_pub_id"
        disableLink
        disablePublisherLink
        withoutStore
        appIconSize={40}
        appIconBordered
      />
      <p className="metric-name">{data.metric_name}</p>
    </div>
    <div className="models-slide-content-chart">
      {isActive && (
        <Chart
          metric_time_series={data.metric_time_series}
          kpi_time_series={data.kpi_time_series}
        />
      )}
    </div>
  </div>
);

Slide.propTypes = {
  data: T.object.isRequired,
  isActive: T.bool,
};

export default Slide;
